import styled from 'styled-components';

export const FormGroup = styled.div`
    & + & {
        margin-top: 20px;   
    }
`